import React, { useState, useEffect } from "react";
import { useRequirementFilter } from "../../app/hooks/useRequirementFilter";
import { OMSMultiselectDD } from "../../app/common/common-components/OMSMultiselectTagDropdown";
import { OMSNumericBox } from "../../app/common/common-components/OMSComponent";
import { OMSTwitterAutocomplete2 } from "../../app/common/common-components/OMSAutocomplete";
import { OMSButtonStyleL } from "../../app/common/common-components/OMSButton";
import HelpLinkIcon from "@/app/common/common-components/HelpLinkIcon";

export const RequirementFilterModal = ({
  isOpen,
  onClose,
  onSave,
  onReset,
  initialFilters,
}) => {
  const { requirementInfo, dropdownData, isLoading, handlers } =
    useRequirementFilter(initialFilters);

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const modalElement = window.$("#requirementFilterModel");

    if (isOpen) {
      modalElement.modal("show");
      modalElement.on("hidden.bs.modal", onClose);
    } else {
      modalElement.modal("hide");
    }

    return () => {
      modalElement.off("hidden.bs.modal", onClose);
    };
  }, [isOpen, onClose]);

  const handleSave = async () => {
    console.log(requirementInfo);
    setIsSaving(true);

    const payload = {
      ...requirementInfo,
      SaleType: requirementInfo.SaleType || "",
      PropertyTypes: requirementInfo.PropertyTypes || [],
      Areas: requirementInfo.Areas || [],
      FloorSize: Number(requirementInfo.FloorSize || 0),
      FloorSizeUnits: Number(requirementInfo.FloorSizeUnits || 0),
      ErfSize: Number(requirementInfo.ErfSize || 0),
      ErfSizeUnits: Number(requirementInfo.ErfSizeUnits || 0),
      BedRooms: Number(requirementInfo.BedRooms || 0),
      Bathrooms: Number(requirementInfo.Bathrooms || 0),
      Garages: Number(requirementInfo.Garages || 0),
      Parkings: Number(requirementInfo.Parkings || 0),
      PriceFrom: Number(requirementInfo.PriceFrom || 0),
      PriceTo: Number(requirementInfo.PriceTo || 0),
    };

    try {
      await onSave(payload);
    } catch (error) {
      console.error("Failed to save filters:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div
      className="modal fade"
      id="requirementFilterModel"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="requirementModelLabel"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          {isLoading ? (
            <div className="modal-body">Loading filter options...</div>
          ) : (
            <>
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={onClose}
                >
                  ×
                </button>
                <h4 className="modal-title">
                  Filter contacts that meet all these requirements
                  <HelpLinkIcon href="https://help.entegral.net/en/articles/12469562-contact-requirement-search" />
                </h4>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>Sale type</small>
                    </label>
                    <select
                      id="SaleType"
                      name="SaleType"
                      className="form-control"
                      style={{ marginRight: 10, maxWidth: 150 }}
                      value={requirementInfo.SaleType}
                      onChange={handlers.handleChange}
                    >
                      <option value="">Sale Type</option>
                      {dropdownData.saleTypeDD.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>Property types</small>
                    </label>
                    <OMSMultiselectDD
                      id="PropertyTypes"
                      style={{ maxWidth: 150 }}
                      value={requirementInfo.PropertyTypes}
                      data={dropdownData.propertyTypeDD}
                      onChange={handlers.onPropertyTypesChange}
                    />
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>Floor size min</small>
                    </label>
                    <div className="input-group">
                      <OMSNumericBox
                        id="FloorSize"
                        name="FloorSize"
                        placeholder="Floor size min"
                        maxLength={10}
                        style={{ maxWidth: 150 }}
                        value={requirementInfo.FloorSize || ""}
                        isDecimal={true}
                        onChange={handlers.handleNumericChange}
                      />
                      <div className="input-group-btn">
                        <button
                          type="button"
                          className="btn btn-default dropdown-toggle form-button"
                          data-toggle="dropdown"
                        >
                          {requirementInfo.FloorSizeUnits === "1"
                            ? "m²"
                            : requirementInfo.FloorSizeUnits === "2"
                              ? "ft²"
                              : "ht"}{" "}
                          <span className="caret"></span>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-right">
                          <li
                            onClick={() =>
                              handlers.handleUnitChange("FloorSizeUnits", "1")
                            }
                          >
                            <a>m²</a>
                          </li>
                          <li
                            onClick={() =>
                              handlers.handleUnitChange("FloorSizeUnits", "2")
                            }
                          >
                            <a>ft²</a>
                          </li>
                          <li
                            onClick={() =>
                              handlers.handleUnitChange("FloorSizeUnits", "3")
                            }
                          >
                            <a>hectares</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>Land size min</small>
                    </label>
                    <div className="input-group">
                      <OMSNumericBox
                        id="ErfSize"
                        name="ErfSize"
                        placeholder="Land size min"
                        maxLength={10}
                        style={{ maxWidth: 150 }}
                        value={requirementInfo.ErfSize || ""}
                        isDecimal={true}
                        onChange={handlers.handleNumericChange}
                      />
                      <div className="input-group-btn">
                        <button
                          type="button"
                          className="btn btn-default dropdown-toggle form-button"
                          data-toggle="dropdown"
                        >
                          {requirementInfo.ErfSizeUnits === "1"
                            ? "m²"
                            : requirementInfo.ErfSizeUnits === "2"
                              ? "ft²"
                              : "ht"}{" "}
                          <span className="caret"></span>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-right">
                          <li
                            onClick={() =>
                              handlers.handleUnitChange("ErfSizeUnits", "1")
                            }
                          >
                            <a>m²</a>
                          </li>
                          <li
                            onClick={() =>
                              handlers.handleUnitChange("ErfSizeUnits", "2")
                            }
                          >
                            <a>ft²</a>
                          </li>
                          <li
                            onClick={() =>
                              handlers.handleUnitChange("ErfSizeUnits", "3")
                            }
                          >
                            <a>hectares</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 10 }}>
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>Bedrooms min</small>
                    </label>
                    <OMSNumericBox
                      id="BedRooms"
                      name="BedRooms"
                      placeholder="Beds"
                      maxLength={10}
                      style={{ maxWidth: 150 }}
                      value={requirementInfo.BedRooms || ""}
                      isDecimal={true}
                      onChange={handlers.handleNumericChange}
                    />
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>Bathrooms min</small>
                    </label>
                    <OMSNumericBox
                      id="Bathrooms"
                      name="Bathrooms"
                      placeholder="Bathrooms"
                      maxLength={10}
                      style={{ maxWidth: 150 }}
                      value={requirementInfo.Bathrooms || ""}
                      isDecimal={true}
                      onChange={handlers.handleNumericChange}
                    />
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>Garages min</small>
                    </label>
                    <OMSNumericBox
                      id="Garages"
                      name="Garages"
                      placeholder="Garages"
                      maxLength={10}
                      style={{ maxWidth: 150 }}
                      value={requirementInfo.Garages || ""}
                      isDecimal={true}
                      onChange={handlers.handleNumericChange}
                    />
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>Parking bays min</small>
                    </label>
                    <OMSNumericBox
                      id="Parkings"
                      name="Parkings"
                      placeholder="Parking bays"
                      maxLength={10}
                      style={{ maxWidth: 150 }}
                      value={requirementInfo.Parkings || ""}
                      isDecimal={true}
                      onChange={handlers.handleNumericChange}
                    />
                  </div>
                </div>

                <br />
                <div className="row">
                  <div className="col-md-12">
                    <label>Price range</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>From</small>
                    </label>
                    <OMSNumericBox
                      id="PriceFrom"
                      name="PriceFrom"
                      separator=","
                      placeholder="Price from"
                      maxLength={10}
                      style={{ maxWidth: 120 }}
                      value={requirementInfo.PriceFrom || ""}
                      isDecimal={true}
                      onChange={handlers.handleNumericChange}
                    />
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <label>
                      <small style={{ color: "grey" }}>To</small>
                    </label>
                    <OMSNumericBox
                      id="PriceTo"
                      name="PriceTo"
                      separator=","
                      placeholder="Price to"
                      maxLength={10}
                      style={{ maxWidth: 120 }}
                      value={requirementInfo.PriceTo || ""}
                      isDecimal={true}
                      onChange={handlers.handleNumericChange}
                    />
                  </div>
                </div>

                <br />
                <div className="row">
                  <div className="col-md-12">
                    <label>Areas</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <OMSTwitterAutocomplete2
                      id="SelectedAreas"
                      name="SelectedAreas"
                      value=""
                      onSelect={handlers.areaSelectionChanged}
                      clearOnSelect
                      strictMatch
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {requirementInfo.Areas?.length > 0 && (
                      <div
                        className="search-bar__autocomplete-input d-flex flex-wrap"
                        style={{
                          border: "1px solid rgba(0,0,0,0.2)",
                          borderRadius: "4px",
                          padding: "4px",
                          minHeight: "40px",
                          marginTop: "5px",
                        }}
                      >
                        {requirementInfo.Areas.map((area, index) => (
                          <div
                            key={index}
                            className="search-bar__autocomplete-selected"
                            style={{
                              backgroundColor: "#bbbbbb",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              margin: "2px",
                              display: "flex",
                              alignItems: "center",
                              color: "#ffffff",
                            }}
                          >
                            {area}
                            <i
                              onClick={() =>
                                handlers.areaSelectionRemoved(area)
                              }
                              className="fa fa-trash"
                              style={{
                                fontSize: 18,
                                cursor: "pointer",
                                marginLeft: 8,
                                color: "#ffffff",
                              }}
                            ></i>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  style={{
                    cursor: "pointer",
                    color: "#148488",
                    marginRight: "20px",
                    textDecoration: "underline",
                    fontWeight: "500",
                    fontSize: "16px",
                  }}
                  onClick={onReset}
                >
                  Reset
                </span>
                <OMSButtonStyleL
                  type="button"
                  ui_icon="fa-check"
                  ui_type="save"
                  ui_text="Save"
                  ui_processing_text="Saving.."
                  processing={isSaving}
                  disabled={isSaving}
                  onClick={handleSave}
                />
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
